import React from "react";

const ARFormLabel = ({text, className = ''}) => {
    if (!text) {
        return null;
    }
    return (
        <div className={`d-flex justify-content-center ${className}`}>
            <div className={"border p-1"} style={{display: 'inline', fontSize: '18px', background: '#ebdbbf', color: '#8f7a3a', borderColor: '#f7f2e7'}}>
                {text}
                <i className={"zmdi zmdi-alert-triangle ml-1"}></i>
            </div>
        </div>
    );
}

export { ARFormLabel };